import { useTranslation } from 'react-i18next';

/** Shared empty-state and placeholder strings for domain select components. */
export function useSelectLabels() {
  const { t } = useTranslation('common');
  return {
    noProducts: t('select.noProducts'),
    noEmployees: t('select.noEmployees'),
    noCustomers: t('select.noCustomers'),
    noSuppliers: t('select.noSuppliers'),
    noStores: t('select.noStores'),
    noProjects: t('select.noProjects'),
    noCourses: t('select.noCourses'),
    noShifts: t('select.noShifts'),
    noDepartments: t('select.noDepartments'),
    noDesignations: t('select.noDesignations'),
    noGrades: t('select.noGrades'),
    noBusinessUnits: t('select.noBusinessUnits'),
    noPurchaseOrders: t('select.noPurchaseOrders'),
    noPurchaseRequests: t('select.noPurchaseRequests'),
    noRfqs: t('select.noRfqs'),
    noLeaveTypes: t('select.noLeaveTypes'),
    noShiftTypes: t('select.noShiftTypes'),
    noEmploymentTypes: t('select.noEmploymentTypes'),
    noExpenseTypes: t('select.noExpenseTypes'),
    noDocumentTypes: t('select.noDocumentTypes'),
    noOvertimeTypes: t('select.noOvertimeTypes'),
    searchProduct: t('select.searchProduct'),
    searchProductDetail: t('select.searchProductDetail'),
    none: t('select.none'),
    noManager: t('select.noManager'),
    selectEmployee: t('select.selectEmployee'),
    selectCustomer: t('select.selectCustomer'),
    selectSupplier: t('select.selectSupplier'),
    selectSuppliers: t('select.selectSuppliers'),
    selectLeaveType: t('select.selectLeaveType'),
    selectPurchaseRequestOptional: t('select.selectPurchaseRequestOptional'),
    selectEmployees: t('select.selectEmployees'),
    selectProject: t('select.selectProject'),
    searchPurchaseOrder: t('select.searchPurchaseOrder'),
    selectManager: t('select.selectManager'),
    selectEmploymentType: t('select.selectEmploymentType'),
    selectShiftType: t('select.selectShiftType'),
    selectDepartment: t('select.selectDepartment'),
    selectDesignation: t('select.selectDesignation'),
    selectGrade: t('select.selectGrade'),
    selectBusinessUnit: t('select.selectBusinessUnit'),
    selectExpenseType: t('select.selectExpenseType'),
    selectDocumentType: t('select.selectDocumentType'),
    selectShift: t('select.selectShift'),
    selectStore: t('select.selectStore'),
    selectCourse: t('select.selectCourse'),
    searchRfq: t('select.searchRfq'),
    selectOvertimeType: t('select.selectOvertimeType'),
    selectProduct: t('select.selectProduct'),
    selectCountry: t('select.selectCountry'),
    selectCurrency: t('select.selectCurrency'),
    selectTimezone: t('select.selectTimezone'),
    selectLanguage: t('select.selectLanguage'),
    searchAndSelectEmployees: t('select.searchAndSelectEmployees'),
    searchEmployee: t('select.searchEmployee'),
    searchEmploymentTypes: t('select.searchEmploymentTypes'),
    searchShiftTypes: t('select.searchShiftTypes'),
    searchDepartments: t('select.searchDepartments'),
    searchDesignations: t('select.searchDesignations'),
    searchGrades: t('select.searchGrades'),
    searchBusinessUnits: t('select.searchBusinessUnits'),
    searchLeaveTypes: t('select.searchLeaveTypes'),
    searchCustomers: t('select.searchCustomers'),
    searchOvertimeTypes: t('select.searchOvertimeTypes'),
    searchSuppliers: t('select.searchSuppliers'),
    searchSuppliersDetail: t('select.searchSuppliersDetail'),
    searchPoNumber: t('select.searchPoNumber'),
    searchProjects: t('select.searchProjects'),
    searchRequestNumber: t('select.searchRequestNumber'),
    searchShifts: t('select.searchShifts'),
    searchCourses: t('select.searchCourses'),
    searchDocumentTypes: t('select.searchDocumentTypes'),
    searchStores: t('select.searchStores'),
    searchRfqNumber: t('select.searchRfqNumber'),
    searchCountries: t('select.searchCountries'),
    searchCurrencies: t('select.searchCurrencies'),
    searchTimezones: t('select.searchTimezones'),
    searchLanguages: t('select.searchLanguages'),
    searchExpenseTypes: t('select.searchExpenseTypes'),
    searchProductBarcode: t('select.searchProductBarcode'),
    searchBills: t('select.searchBills'),
    searchMasterAdmins: t('select.searchMasterAdmins'),
    searchEmailName: t('select.searchEmailName'),
    loadingStores: t('select.loadingStores'),
    noCountries: t('select.noCountries'),
    noCurrencies: t('select.noCurrencies'),
    noTimezones: t('select.noTimezones'),
    noLanguages: t('select.noLanguages'),
  };
}
